import { animated } from '@react-spring/web';
import { type AxisTickProps } from '@nivo/axes';
import colors from '../../../styles/chakra/colors';

import type { JSX } from 'react';

const BarChartAxisRightTicks = ({
  animatedProps,
  textBaseline,
  textAnchor,
  value,
}: AxisTickProps<any>): JSX.Element => {
  return (
    <animated.g transform={animatedProps.transform} opacity={animatedProps.opacity}>
      <animated.text
        className="bottom-axis-label text-xs-regular"
        dominantBaseline={textBaseline as never}
        textAnchor={textAnchor as never}
        transform={animatedProps.textTransform}
        fill={colors.gray[600]}
      >
        {value}
      </animated.text>
    </animated.g>
  );
};

export default BarChartAxisRightTicks;
